module.exports = __webpack_public_path__ + "img/sRomaII_193x205.da31c3b0.png";